import React from 'react';
import styles from './Sidebar.css';

import SidebarPanelHeader from './SidebarPanelHeader';

function SidebarPanel({
  activeItem,
  isSidebarActive,
  closeSidebarPanel,
  color
}) {
  return (
    <div
      className={
        isSidebarActive
          ? styles.activeSidebarPanel + ' mag-sidebar-panel'
          : styles.sidebarPanel + ' mag-sidebar-panel'
      }
    >
      <SidebarPanelHeader
        className={styles.sidebarPanelHeader}
        title={activeItem ? activeItem.panelTitle : ''}
        closeSidebarPanel={closeSidebarPanel}
      />
      {activeItem ? activeItem.panel() : ''}
    </div>
  );
}

export default SidebarPanel;
